
export default ({
  name: "FooterPart"
});
